/* eslint-disable react/jsx-no-undef */
import { Button, Grid, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import DialogEditTable from "../component/backend-gencode/DialogEditTable";
import TableDatabaseItem from "../component/backend-gencode/TableDatabaseItem";
import PopUpConfirm from "../component/genaral-component/PopupConfirm";
import {
	backendTemplateController,
	tableSequelizeController,
} from "../controller";
import { useCrudHook } from "../helpers/CrudHook";
import { modelsData } from "../helpers/Data";
import { BackendTemplate } from "../model/model/gencode/BackendTemplate";
import { ConfigSequelize } from "../model/setup-sequelize/ConfigSequelize";
import { Model } from "../model/setup-sequelize/Model";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SettingTemplateBackend from "./SettingTemplateBackend";


export default function TableTool() {
	const [template, setTemplate] = useState<BackendTemplate[]>([]);
	const [templateSelected, setTemplateSelected] = useState<BackendTemplate>();
	const crud = useCrudHook<Model>({
		controller: tableSequelizeController,
		isSetQueryWhenSave: true,
	});
	const exportCode = ()=>{
		let templateReplace: string= tableSequelizeController.replaceCode(templateSelected || {},crud.pagingList?.rows || [] );
		tableSequelizeController.downloadCode(templateReplace);
	} 
	useEffect(() => {
		backendTemplateController.find().then((res) => {
			setTemplate(res || []);
			setTemplateSelected(res[0])
		});
	}, []);

	return (
		<Grid container>
			<Grid container justify="space-between">
				<Grid xs= {4}>
					<Button
						variant="contained"
						color="primary"
						onClick={(e) => crud.onShowPopup({})}
					>
						Add new
					</Button>
				</Grid>
				<Grid container xs={8} justify = "space-between">
					<Autocomplete
						value = {templateSelected || {}}
						options={template}
						getOptionLabel={(option: any) => option.name}
						style={{ width: 300 }}
						onChange = {(e,value)=>{
							if(value){
								setTemplateSelected(value)
							}
						}}
						renderInput={(params: any) => (
							<TextField
								{...params}
								label="Combo box"
								variant="standard"
							/>
						)}
					/>
					<Button
						variant="contained"
						color="primary"
						onClick={(e) => {
							exportCode()
						}}
					>
						Export Code
					</Button>
				</Grid>
			</Grid>
			<DialogEditTable
				isDisplay={crud.isShowPopup}
				item={crud.itemSelected}
				onEdit={crud.onSave}
				onCancel={crud.onCancelPopup}
			/>
			<PopUpConfirm
				isDisplay={crud.isShowConfirm}
				onCancel={crud.onCancelConfirm}
				onDelete={() => {
					crud.onDelete(crud.itemSelected);
				}}
			/>
			{crud.pagingList.rows?.map((model) => {
				return (
					<TableDatabaseItem
						item={model}
						onDelete={crud.onConfirm}
						onEdit={(item: Model) => {
							crud.onShowPopup(item);
						}}
					/>
				);
			})}
		</Grid>
	);
}
